module.exports = __webpack_public_path__ + "img/c.7722298b.jpg";